module.exports = fox._r("images/empty_avatar_unknown.png", __webpack_public_path__ + "_/_/_/root/images/empty_avatar_unknown.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/empty_avatar_unknown.png
// module id = 10
// module chunks = 4